import { useTranslation } from 'react-i18next';

import { ClinkingCups } from '@cfa/brand-icons';
import { Button, Modal } from '@cfa/react-core';

import { itemByLanguage } from '@/utils/language';

interface CongratulationsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGetCertificate?: () => void;
  planName: Record<string, string>;
}

const CongratulationsModal: React.FC<CongratulationsModalProps> = ({
  isOpen,
  onClose,
  onGetCertificate,
  planName,
}) => {
  const { t } = useTranslation();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Modal.Overlay
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      isDismissable
      className="z-2000"
    >
      <Modal.Dialog size="lg" className="w-[536px]!" isDismissable>
        <Modal.Title className="text-center">
          <p className="text-grayscale-gray6 pt-7 pb-3 text-2xl/8 font-bold">
            {t('Generic.congratulations', 'Congratulations!')}
          </p>
        </Modal.Title>
        <Modal.Content className="mb-5! items-center! text-center!">
          <ClinkingCups
            size={64}
            aria-hidden="true"
            color="primary"
            className="mb-3!"
          />
          <p className="text-grayscale-gray6 text-base/6 font-bold whitespace-pre-line">
            {t('TrainingPlans.certificatePlanComplete', {
              planName: itemByLanguage(planName),
            })}
          </p>
        </Modal.Content>
        <Modal.Footer className="px-14! pt-4! pb-15!">
          <div className="flex w-full flex-wrap justify-center gap-4">
            {onGetCertificate && (
              <Button
                color="secondary"
                variant="outlined"
                className="min-w-[200px]! flex-1!"
                onPress={onGetCertificate}
              >
                {t('Button.getCertificate', 'Get Certificate')}
              </Button>
            )}
            <Button
              color="secondary"
              variant="filled"
              className="min-w-[200px]! flex-1!"
              onPress={onClose}
            >
              {t('Button.close')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal.Overlay>
  );
};

export default CongratulationsModal;
